'use strict';
var app = require('angular').module('waiting', []);

app.controller('waitingCtrl', ['Authentication', '$state', '$timeout', '$q', '$rootScope', require('./waitingCtrl')]);
app.config(['$stateProvider', require('./waitingConfig')]);
